// extracted by mini-css-extract-plugin
module.exports = {"buttonName":"BackHomeButton_buttonName__2xv3r","button":"BackHomeButton_button__1CZ85","link":"BackHomeButton_link__6Qc3I","icon":"BackHomeButton_icon__2Wwea"};